import React, { Suspense } from 'react';
import { useMediaQuery } from 'react-responsive';
import { Stack } from '@mui/material';

//  components
import { LoadingSpinner } from '../../components/Common/LoadingSpinner';
import Error from '../../pages/Error';

//  utils
import LogRocket from 'logrocket';
import { ErrorBoundary } from 'react-error-boundary';

//  redux
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../redux/store';
import { changeStatus } from '../../redux/search';

//  Lazy Pages
const SearchPage = React.lazy(() => import('../../pages/Search'));

const Container = ({ child }: { child: JSX.Element }): JSX.Element => {
  const isMobile = useMediaQuery({ maxWidth: 786 });
  return (
    <Stack minWidth={ isMobile ? 'auto' : '830px' } sx={{ overflowY: 'auto', boxSizing: 'border-box', m: '10px', borderRadius: 2.5, boxShadow: 5, backgroundColor: 'light.main', height: `calc(100% - 20px)`, width: isMobile ? 'calc(100% - 20px)' : '60%' }}>
      { child }
    </Stack>
  )
}

export const LazySearch = () => {
  //  hooks
  const dispatch = useDispatch();

  const searchOpened = useSelector((state: RootState) => state.search.opened);

  const closeSearch = () => {
    dispatch(changeStatus(false));
  }

  return (
    searchOpened ?
    <Stack sx={{ backgroundColor: 'rgba(186, 186, 186, 0.50)', position: 'absolute', width: '100%', height: '100%', top: 0, zIndex: 2 }} onClick={closeSearch}>
      <ErrorBoundary
        fallback={
          <Container child={<Error type={'RELOAD'} />} />
        }
        onError={(error) => {
          LogRocket.captureException(error, {
            tags: { type: 'chunk load failure' },
            extra: { reason: 'Loading Search Screen' }
          });
        }}
      >
        <Suspense fallback={
          <Container child={<LoadingSpinner />} />
        }>
          <SearchPage />
        </Suspense>
      </ErrorBoundary>
    </Stack> :
    <></>
  );
}
